export const queryKeys = {
  documents: () => ['documents'] as const,
  domains: () => ['domains'] as const,
  document: (docId: string) => ['document', docId] as const,
  annotations: (isAdmin: boolean) => ['annotations', { isAdmin }] as const,
  pnidState: (docId: string) => ['pnid-state', docId] as const,
  publishableAssets: (docId: string) => ['publishable-assets', docId] as const,
  equipmentTypes: () => ['equipment-types'] as const,
  formSchemas: () => ['form-schemas'] as const,
  registerContext: (docId: string) => ['register-context', docId] as const,
  plants: () => ['plants'] as const,
  plantHierarchy: (domainId: string) => ['plants', domainId, 'hierarchy'] as const,
  plantPublishPlan: (domainId: string) => ['plants', domainId, 'publish-plan'] as const,
  redundancySets: {
    all: () => ['redundancy-sets'] as const,
    list: (domainId: string) => ['redundancy-sets', domainId] as const,
  },
  legendSheets: {
    all: () => ['legend-sheets'] as const,
    list: (domainId: string) => ['legend-sheets', domainId] as const,
  },
  tagSuggestions: (docId: string, kind: string, query: string) =>
    ['tag-suggestions', docId, kind, query] as const,
  aiData: (docId: string) => ['ai-data', docId] as const,
  plantModelExists: (docId: string) => ['plant-model-exists', docId] as const,
  templateAnnotations: (docId: string) => ['template-annotations', docId] as const,
  comments: (docId: string) => ['comments', docId] as const,
  groqVisionStatus: () => ['groq-vision-status'] as const,
  workspaceConfig: () => ['workspace-config'] as const,
};
